import { ESTADOS_CONSULTA } from '../../utils/consultas'

export default function EstadoConsultaBadge({ estado }) {
  const { label, className } = ESTADOS_CONSULTA[estado] ?? ESTADOS_CONSULTA.pendiente
  return <span className={'inline-flex rounded-full border px-2.5 py-1 text-xs font-semibold ' + className}>{label}</span>
}
